import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Dedicated route for organization admins to view + manage their Stripe
 * subscription.  Redirects to the existing AdminSettingsPage billing tab so
 * we don't duplicate the BillingPanel component, while still giving the
 * practice admin a direct sidebar link / URL to share.
 */
export default function OrgSubscriptionPage() {
  const { user } = useAuth();
  if (!user) return null;
  // Super admins should use the platform-wide view.
  if (user.role === 'super_admin') {
    return <Navigate to="/admin/subscriptions" replace />;
  }
  // Practice admins (and anyone else authorised) get the billing tab.
  return <Navigate to="/admin/settings?tab=billing" replace />;
}
